import React from 'react';
import { View } from 'react-native';
import moment from 'moment';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
import { Divider } from '../../../Divider';
const weekdays = moment.weekdays();
export const Days = () => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container },
        weekdays.map((day, index) => (React.createElement(View, { key: day, style: [styles.day, index !== 0 ? styles.dayWithMargin : {}] },
            React.createElement(View, { style: styles.hours })))),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '0%' }] }),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '25%' }] }),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '50%' }] }),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '75%' }] }),
        React.createElement(Divider, { type: 'vertical', style: [styles.divider, { right: '100%' }] })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        paddingTop: size.G,
        marginTop: size.A
    },
    day: { alignItems: 'center', flexDirection: 'row', height: size.M },
    dayWithMargin: { marginTop: size.C },
    hours: {
        backgroundColor: color.invert2.p4,
        flex: 1,
        height: '100%'
    },
    divider: {
        position: 'absolute',
        height: '100%',
        top: 0
    }
}));
//# sourceMappingURL=Days.js.map